import { SceneManager } from '../core/SceneManager';
import { ThreeDObject } from '../interfaces/ThreeDObject';

// Observer pattern for animation updates
export class AnimationController {
    private sceneManager: SceneManager;
    private objects: ThreeDObject[] = [];
    private animationId: number | null = null;
    private isRunning: boolean = false;

    constructor() {
        this.sceneManager = SceneManager.getInstance();
    }

    public addObject(object: ThreeDObject): void {
        this.objects.push(object);
        this.sceneManager.addToScene(object.create());
    }

    public removeObject(object: ThreeDObject): void {
        const index = this.objects.indexOf(object);
        if (index > -1) {
            this.objects.splice(index, 1);
            this.sceneManager.removeFromScene(object.create());
        }
    }

    public start(): void {
        if (!this.isRunning) {
            this.isRunning = true;
            this.animate();
        }
    }

    public stop(): void {
        this.isRunning = false;
        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
            this.animationId = null;
        }
    }

    private animate = (): void => {
        if (!this.isRunning) return;

        const currentTime = performance.now();

        this.objects.forEach(obj => {
            obj.animate(currentTime);
        });

        this.sceneManager.render();
        this.animationId = requestAnimationFrame(this.animate);
    };

    public destroy(): void {
        this.stop();
        this.objects.length = 0;
    }
}
